<template>
  <div>
    <b-row>
      <b-col xs="12">
        <h2 class="text-left mt-3 mb-5 font-weight-normal">Kiemelt programok</h2>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-card-group style="width: 100%;">
        <b-col class="text-center" sm="12" md="12" lg="12" xl="12">
          <carousel
            :per-page="2"
            :mouse-drag="true"
            :perPageCustom="responsiveCarouselSetting"
            :navigationEnabled="false"
            :autoplay="true"
            :loop="true"
            :autoplayTimeout="5000"
            paginationActiveColor="#3ba7de"
            paginationColor="#6F6F6F"
            :paginationSize="20"
          >
            <!-- <slide>
              <a href="https://dsprogram.hu/demjansandorprogram/" target="_blank">
                <b-card tag="article" class="p-2 dsp-box box1 h-100 d-flex justify-content-center align-items-center">
                  <b-card-title class="text-center white-circle text-uppercase">
                    <div>
                      <b-img src="../assets/img/DSP/ds_program.png" fluid alt="Responsive image"></b-img>
                    </div>
                  </b-card-title>
                </b-card>
              </a>
            </slide> -->
            <slide>
              <a href="https://www.moderngyarakejszakaja.hu/" target="_blank">
                <b-card tag="article" class="p-2 mgye-box h-100 d-flex justify-content-center align-items-center">
                  <b-card-title class="text-center white-circle text-uppercase">
                    <div>
                      <b-img src="../assets/img/logo/card-mgye.png" fluid alt="Responsive image"></b-img>
                    </div>
                  </b-card-title>
                </b-card>
              </a>
            </slide>
            <slide>
              <a href="https://seed.hu/szintlepes/" target="_blank">
                <b-card
                  tag="article"
                  class="p-2 dsp-box seed_slide h-100 d-flex justify-content-center align-items-center"
                >
                  <b-card-title class="text-center white-circle text-uppercase">
                    <div>
                      <b-img src="../assets/img/logo/SEED_tile.png" fluid alt="Responsive image"></b-img>
                    </div>
                  </b-card-title>
                </b-card>
              </a>
            </slide>
            <slide>
              <a href="https://nemzetibajnokok.hu" target="_blank">
                <b-card
                  tag="article"
                  class="p-2 nemzetibb-box box2 h-100 d-flex justify-content-center align-items-center"
                >
                  <b-card-title class="text-center white-circle text-uppercase">
                    <div>
                      <b-img src="../assets/img/Nemzeti_Bajnokok_Program.png" fluid alt="Responsive image"></b-img>
                    </div>
                  </b-card-title>
                </b-card>
              </a>
            </slide>
            <slide>
              <a href="https://ginopplusz.modem4.hu/" target="_blank">
                <b-card
                  tag="article"
                  class="p-2 energiatamogatas-box box1 h-100 d-flex justify-content-center align-items-center momip-box"
                >
                  <b-card-title class="text-center white-circle text-uppercase">
                    <div class="">
                      <b-img src="../assets/img/logo/momip.png" fluid alt="Responsive image"></b-img>
                    </div>
                  </b-card-title>
                </b-card>
              </a>
            </slide>
            <slide>
              <a href="https://vali.hu/ESG/Szolgaltatasok" target="_blank">
                <b-card tag="article" class="p-2 esg_card box2 h-100 d-flex justify-content-center align-items-center">
                  <b-card-title class="text-center white-circle text-uppercase">
                    <div>
                      <b-img src="../assets/img/logo/esg_card.png" fluid alt="Responsive image"></b-img>
                    </div>
                  </b-card-title>
                </b-card>
              </a>
            </slide>
            <!-- <slide>
              <a href="https://vali.hu/energiatamogatas" target="_blank">
                <b-card
                  tag="article"
                  class="p-2 energiatamogatas-box box1 h-100 d-flex justify-content-center align-items-center mgfu-box"
                >
                  <b-card-title class="text-center white-circle text-uppercase">
                    <div class="">
                      <b-img src="../assets/img/logo/mgfu-energiatamogatas.png" fluid alt="Responsive image"></b-img>
                    </div>
                  </b-card-title>
                </b-card>
              </a>
            </slide> -->
            <slide>
              <a href="https://evolucio.ifka.hu/" target="_blank">
                <b-card
                  tag="article"
                  class="p-2 highlighted-program-box box4 h-100 d-flex justify-content-center align-items-center"
                >
                  <b-card-title class="text-center white-circle text-uppercase">
                    <div class="svg-border">
                      <evo-svg />
                    </div>
                  </b-card-title>
                </b-card>
              </a>
            </slide>
            <slide>
              <a href="https://www.vallalkozzdigitalisan.hu/" target="_blank">
                <b-card
                  tag="article"
                  class="p-2 highlighted-program-box box6 h-100 d-flex justify-content-center align-items-center"
                >
                  <b-card-title class="text-center white-circle text-uppercase">
                    <div class="svg-border mt-2">
                      <b-img src="../assets/img/mvp.png" fluid alt="Responsive image"></b-img>
                    </div>
                  </b-card-title>
                </b-card>
              </a>
            </slide>
          </carousel>
        </b-col>
      </b-card-group>
    </b-row>
  </div>
</template>

<script>
import EvoSvg from '@/components/svg/ProgramsHighlight/Evo.vue'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'ProgramsHighlight',
  components: {
    Carousel,
    Slide,
    EvoSvg
  },
  data() {
    return {
      responsiveCarouselSetting: [
        [320, 1],
        [991, 2],
        [1299, 3]
      ]
    }
  }
}
</script>

<style>
.esg_card {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ffe-box {
  background-color: #dfe6e9 !important;
}

.mgfu-box {
  background-color: #cad2d5 !important;
}

.dsp-box {
  background-color: #bfe6e5 !important;
  border-radius: 7px;
  padding: 30px;
  max-width: 95% !important;
  min-height: 330px;
}

.nemzetibb-box {
  background-color: #eeeeee !important;
  border-radius: 7px;
  padding: 30px;
  max-width: 95% !important;
  min-height: 330px;
}

.esg_card {
  background-color: #367c53 !important;
  border-radius: 7px;
  padding: 30px;
  max-width: 95% !important;
  min-height: 330px;
}

.seed_slide {
  background-color: #edf5d7 !important;
  border-radius: 7px;
  padding: 30px;
  max-width: 95% !important;
  min-height: 330px;
}

.mgye-box {
  background-color: #e8ff61 !important;
  border-radius: 7px;
  padding: 30px;
  max-width: 95% !important;
  min-height: 330px;
}

.momip-box {
  background-color: #545453 !important;
}

.energiatamogatas-box {
  border-radius: 7px;
  padding: 30px;
  max-width: 95% !important;
  min-height: 330px;
}
.highlighted-program-box {
  border-radius: 7px;
  padding: 30px;
  padding-top: 70px !important;
  max-width: 95% !important;
  min-height: 330px;
}
.box1 {
  background: #1c1f4d;
}

.box2 {
  background: #1d3618;
}

.box3 {
  background: #0d0053;
}

.box4 {
  background: #362b45;
}

.box5 {
  background: #545453;
}

.box6 {
  background: #a7d5d4;
}
</style>
